import { render, staticRenderFns } from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=template&id=4f166dc8&scoped=true"
import script from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=style&index=0&id=4f166dc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f166dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f166dc8')) {
      api.createRecord('4f166dc8', component.options)
    } else {
      api.reload('4f166dc8', component.options)
    }
    module.hot.accept("./ProductReportsDashboardSkuBriefModal.vue?vue&type=template&id=4f166dc8&scoped=true", function () {
      api.rerender('4f166dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/product-reports-dashboard/ProductReportsDashboardSkuBriefModal.vue"
export default component.exports